import { loadGoogle } from '../common/help-functions'

export default async function () {
  const sections = document.querySelectorAll('.contacts-section')

  const google = await loadGoogle()

  sections.forEach(section => {
    // const loader = new Loader(window.googleApiKey)

    // loader.load().then(initMap)
    const point = {
      lat: Number(section.getAttribute('map-lat')),
      lng: Number(section.getAttribute('map-lng')),
    }

    const map = new google.maps.Map(section.querySelector('[contact-map]'), {
      zoom: 15,
      center: {
        lat: point.lat,
        lng: point.lng,
      },
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'all',
          elementType: 'geometry',
          stylers: [
            {
              color: '#202c3e',
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [
            {
              gamma: 0.01,
            },
            {
              lightness: 20,
            },
            {
              weight: '1.39',
            },
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              weight: '0.96',
            },
            {
              saturation: '9',
            },
            {
              visibility: 'on',
            },
            {
              color: '#000000',
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              lightness: 30,
            },
            {
              saturation: '9',
            },
            {
              color: '#29446b',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#0c1137',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              saturation: 20,
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              lightness: 20,
            },
            {
              saturation: -20,
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              lightness: 10,
            },
            {
              saturation: -30,
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#555c67',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [
            {
              saturation: 25,
            },
            {
              lightness: 25,
            },
            {
              weight: '0.01',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              lightness: -20,
            },
            {
              color: '#515575',
            },
          ],
        },
      ],
    })

    new google.maps.Marker({
      position: point,
      map,
      icon: {
        url: '/assets/icons/marker.svg',
        size: new google.maps.Size(40, 40),
      },
    })
  })
}
